import React, { useEffect } from 'react';
import logo from './logo.svg';
import './App.css';
import './locale/i18n'
import { Route, Routes, useLocation } from 'react-router-dom';
import { Test } from './pages/user/test/test';
import LayOut from './pages/user/layout';
import { AdminLogin } from './pages/admin/manager';
import { DashBoard } from './pages/admin/dashboard';
import { getCookie, setCookie } from './util/cookie/cookies';
import { useCookies } from 'react-cookie';
import { useTranslation } from 'react-i18next';
import { EngineModeling } from './components/EngineModeling';

function App() {
  
  const [cookies, setCookies] = useCookies(['HYUNDAILANG']);
  const {i18n} = useTranslation();
  const lang = getCookie('HYUNDAILANG');
  const location = useLocation();
  useEffect(()=>{
    if(lang === undefined){setCookies('HYUNDAILANG', 'kr', {path : '/'}); i18n.changeLanguage('kr')}
    if(lang === 'kr'){i18n.changeLanguage('kr')}
    else {i18n.changeLanguage('en')}
  }, [lang, setCookies])
  return (
    <>
    <Routes>
      <Route path='/' element={<LayOut/>}/>
      <Route path='/about/:secondUrl' element={<LayOut/>} />
      <Route path='/liebherr/:secondUrl' element={<LayOut/>} />
      <Route path='/hyundai/:secondUrl' element={<LayOut/>} />
      <Route path='/hyundai/:secondUrl/:product' element={<LayOut/>} />
      <Route path='/equipmentStatus' element={<LayOut/>} />
      <Route path='/prCenter/:secondUrl' element={<LayOut/>} />
      <Route path='/prCenter/:secondUrl/:thridUrl' element={<LayOut/>} />
      <Route path='/contact/:secondUrl' element={<LayOut/>}/>
      <Route path='/LIEBHERR-ENGINE' element={<EngineModeling/>} />

      <Route path='/dotsAdmin' element={<AdminLogin/>}/>
      <Route path='/dotsAdmin/prCenter/:contentsType' element={<DashBoard/>} />
      <Route path='/dotsAdmin/prCenter/:contentsType/:contentsId' element={<DashBoard/>} />
      <Route path='/dotsAdmin/customerCenter/:contentsType' element={<DashBoard/>} />
      <Route path='/dotsAdmin/customerCenter/:contentsType/:contentsId' element={<DashBoard/>} />
      <Route path='/dotsAdmin/setting/:contentsType' element={<DashBoard/>} />
      <Route path='/dotsAdmin/setting/:contentsType/:contentsId' element={<DashBoard/>} />
    </Routes>
    </>
  );
}

export default App;
